<template>
  <div>
    <div class="mr-b25">
      <div class="title-bar title-h4 dot-title">기본정보</div>
      <el-form :model="formData" :rules="formRules" ref="basicInfoForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="interfaceGroupName" label="인터페이스 그룹명">
              <el-input v-model="formData.interfaceGroupName" placeholder="입력해주세요."></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderbyIndex" label="정렬순서">
              <el-input-number v-model="formData.orderbyIndex" style="width:100%" controls-position="right" :min="1" :max="999" placeholder="입력해주세요."></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="interfaceGroupDesc" label="설명">
          <el-input v-model="formData.interfaceGroupDesc" type="textarea" :rows="5" placeholder="입력해주세요."></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div class="title-bar title-h4 dot-title">인터페이스 추가</div>
      <el-row class="title-bar">
        <div class="mr-r15">인터페이스 목록</div>
        <el-button size="mini" @click="showAddInterfaceView">인터페이스 편집</el-button>
      </el-row>
      <el-table-wrapper max-height="240" :data="interfaceList" :columns="tableColumns" :column-default="columnDefault" :pagination="false" :show-search-tool="false" :show-custom-header="false" ref="interfaceTable"></el-table-wrapper>
    </div>
  </div>
</template>

<script>
import { isEmpty, cloneDeep } from 'lodash';
import { convertValueForInterfaceSpeed } from '@/utils/number';
import { columnDefault } from '@/constants/table';

export default {
  name: 'WBasicInfoSettingView',
  props: {
    viewParams: Object,
  },
  data() {
    return {
      oldFormData: {},
      formData: {
        interfaceGroupName: '',
        orderbyIndex: 0,
        interfaceGroupDesc: '',
      },
      formRules: {
        interfaceGroupName: {
          required: true,
          message: '값을 입력해주세요',
          trigger: 'change',
        },
        orderbyIndex: {
          required: true,
          message: '순서를 입력해주세요',
          trigger: 'change',
        },
      },
      oldStrInterfaceIds: [],
      interfaceList: [],
      columnDefault,
      tableColumns: [
        // { prop: 'deviceName', label: '장비명' },
        // { prop: 'deviceIp', label: '장비IP', width: 150 },
        // { prop: 'netinterfaceName', label: '인터페이스명' },
        // { prop: 'speed', label: '인터페이스 속도 (bps)', width: 150, formatter: this.convertUnitValue },
        { prop: 'deviceName', label: '장비 명', remoteProp: 'obj_name', searchable: true },
        { prop: 'ipaddress', label: '장비 IP', width: 150, searchable: true },
        { prop: 'objName', label: '인터페이스 명', remoteProp: 'netinterface_name', searchable: true },
        { prop: 'netinterfaceName', label: '물리 인터페이스 명', remoteProp: 'ni.netinterface_name', searchable: true },
      ],
    };
  },
  watch: {
    'viewParams.interfaceList': {
      handler(list) {
        this.interfaceList = cloneDeep(list);
      },
      immediate: true,
    },
    'viewParams.orderbyIndex': {
      handler(index) {
        this.formData.orderbyIndex = index;
      },
      immediate: true,
    },
    'viewParams.selectedRecord': {
      handler(record) {
        if (!isEmpty(record)) {
          this.formData = {
            interfaceGroupName: record.interfaceGroupName,
            orderbyIndex: record.orderbyIndex,
            interfaceGroupDesc: record.interfaceGroupDesc,
          };
          this.oldFormData = cloneDeep(this.formData);
          this.oldStrInterfaceIds = record.interfaceList.map((ni) => ni.netinterfaceId);
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 인터페이스 그룹 추가/수정에 필요한 정보 가공
     * @author jeee12
     */
    getBasicInfo() {
      const validate = this.$refs.basicInfoForm.validate;
      let basicInfo = {};

      if (isEmpty(this.viewParams.selectedRecord)) {
        // 인터페이스 그룹 추가 파라미터 가공
        basicInfo = Object.assign(this.formData, { interfaceList: this.viewParams.interfaceList });
      } else {
        // 인터페이스 그룹 수정 파라미터 가공
        let isInfoChanged = false;
        let isInterfaceListChanged = false;

        const formData = {
          interfaceGroupId: this.viewParams.selectedRecord.interfaceGroupId,
          isGroupDirty: false, // 인터페이스 그룹 기본정보 수정여부 서버호출 파라미터로 전달
        };

        Object.keys(this.formData).forEach((key) => {
          if (this.oldFormData[key] !== this.formData[key]) {
            isInfoChanged = true;
            formData.isGroupDirty = true;
            formData[key] = this.formData[key];
          }
        });

        if (this.interfaceList.length !== this.oldStrInterfaceIds.length) {
          isInterfaceListChanged = true;
        } else {
          this.interfaceList.forEach((ni) => {
            if (this.oldStrInterfaceIds.indexOf(ni.netinterfaceId) === -1) {
              isInterfaceListChanged = true;
            }
          });
        }

        if (isInterfaceListChanged) { // 인터페이스 목록 수정
          basicInfo = Object.assign(formData, { interfaceList: this.interfaceList });
        } else if (isInfoChanged) { // 인터페이스 기본정보 수정
          basicInfo = cloneDeep(formData);
        }
      }

      return {
        validate, // Promise
        basicInfo,
      };
    },
    /**
     * 인터페이스 추가화면으로 전환
     * @author jeee12
     * @return {[type]} [description]
     */
    showAddInterfaceView() {
      this.$emit('change-view', 'addInterfaceView', this.interfaceList);
    },
    /**
     * 테이블 데이터 단위 변환
     * @author jeee12
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    convertUnitValue(row, column, value) {
      return convertValueForInterfaceSpeed(value);
    },
    /**
     * 현재 화면 데이터 초기화
     * @author jeee12
     * @return {[type]} [description]
     */
    initData() {
      this.formData = {
        interfaceGroupName: '',
        orderbyIndex: this.viewParams.orderbyIndex,
        interfaceGroupDesc: '',
      };

      this.$nextTick(() => {
        this.$refs.basicInfoForm.clearValidate();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/TrafficSettings/InterfaceGroupSettings/components/BasicInfoSettingView.vue